import React, { useEffect, useRef, useState } from "react";
import { config } from "../../../../config/domain";
import EdButton from "../../../generic/edButton";
import Loader from "../../../generic/loader";
import {
  CreateChildServiceRequestDetails,
  GetEquityReactivationClientValidation,
} from "../../../service/serviceRequest/srApiService";
import { EmailMobileModification } from "../emailMobileModification/emailMobileModification";
import { FatcaUpdate } from "../fatcaUpdate/fatcaUpdate";
import { IncomeDeclaration } from "../incomeDeclaration/incomeDeclaration";
import { useQuery } from "../../../service/urlHelper";
export const ProfileForm = (props: any) => {
  // const [loader, setLoader] = useState<any>(false);
  const consentType = useQuery().get("consentType");
  const parentSrDetails: any = JSON.parse(
    localStorage.getItem("accReactParentDetails") || "{}"
  );
  const [fatcaB, setFatcaB] = useState<boolean>(false);
  const [emailB, setEmailB] = useState<boolean>(false);
  const [incomeB, setIncomeB] = useState<boolean>(false);
  const [btnText, setBtnText] = useState<String>("Proceed");
  const addressConsent = useQuery().get("consent");
  const [show, setShow] = useState<any>({
    fatca: true,
    income: true,
    email: true,
  });

  const emailMobRef = useRef();
  const incomeDRef = useRef();
  const fatcaURef = useRef();
  useEffect(() => {
    // setShow({
    //   fatca: props.currentFlow.find((fl: any) => fl.type === 1) ? true : false,
    //   income: props.currentFlow.find((fl: any) => fl.type === 2) ? true : false,
    //   email: props.currentFlow.find((fl: any) => fl.type === 3) ? true : false,
    // });
  }, []);

  const clearLocalStorage = () => {
    window.localStorage.removeItem("digie");
    window.localStorage.removeItem("digieResubmit");
    window.localStorage.removeItem("rejectFlow");
    window.localStorage.removeItem("srId");
    window.localStorage.removeItem("");
  };

  const parentCall = async () => {
    try {
      // props.setLoader(true);
      
      const emailMob: any = emailMobRef?.current;
      const incomeDeclare: any = incomeDRef?.current;
      const fataca: any = fatcaURef?.current;
      const fatcareqObj = await fataca?.getSubmitData();
      const emailMobreqObj = await emailMob?.getSubmitData().reqObj;
      const inDeclreqObj = await incomeDeclare?.getSubmitData();
      delete fatcareqObj?.requestType;
      delete emailMobreqObj?.requestType;
      delete inDeclreqObj?.requestType;
      delete fatcareqObj?.dpID;
      delete emailMobreqObj?.dpID;
      // delete inDeclreqObj?.dpID;
      
      let fatcareq= show.fatca?fatcareqObj: {
        is_indian_citizen: null,
        fatcaReq: []
      }
      const reqObj = {
        requestType: "FATCAINCOMEEMAIL",
        dpID: inDeclreqObj?.dpID ? inDeclreqObj?.dpID : "None",
        ...fatcareq,
        ...emailMobreqObj,
        ...inDeclreqObj,
        AutoQC: "NA",
        parent_id: props.srId,
        dormant_type: parentSrDetails?.dormant_type,
      };


      let emailMobObj = emailMob?.getSubmitData().emailMobileFormObj;

      if (
        !emailMobreqObj.mobOtpVerified && !emailMobObj.emailOtpVerified
      ) {
        // props.setLoader(false);
        emailMob.submitData();
      } else {
        props.setLoader(true);

        const createChildSr = await CreateChildServiceRequestDetails(reqObj);
        // console.log(createChildSr);
        clearLocalStorage();
        props.setLoader(false);

        if (
          typeof createChildSr === "string" &&
          createChildSr.includes("Previous Request already open for this account-")
        ) {
          props.funcData.onSubmit("Profile", {
            headerText: "You have an active service request",
            content: "You already have an active service request. Once it is updated, you will be able to raise new request.",
          });
        } else if (
          typeof createChildSr === "string" &&
          createChildSr.includes("One Service Request with same email/mobile is already open")
        ) {
          props.funcData.onSubmit("Profile", {
            headerText: "Service request rejected",
            content: "The mobile no./email address entered is already in process for updation for a different account. Please update an alternate mobile no./email address to proceed OR since the mobile no./email address pending for updation in a different account is related to you (family account), wait for it to get processed. Once processed, you can use the same mobile no./email address along with family declaration.",
          });
        } else {
          if (createChildSr.Message === "FATCA Declaration,Income Declaration and Email&Phone Request SR is Created successfully")
            props.next(reqObj.familyDeclReq);
          else
            props.funcData.onSubmit("Profile", {
              headerText:
                "There was some error while proceeding with process.Please Try Again Later.",
            });
        }
      }
    } catch (err) {
      //  console.log(err);

      props.setLoader(false);
      props.funcData.onSubmit("Profile", {
        headerText:
          "There was some error while proceeding with process.Please Try Again Later.",
      });
    }
  };

  return (
    <>
      {" "}
      {/* <p>New Income Declaration</p> */}
      <div className="accReactivateWrap">
        <div>
          {show.fatca && (
            <FatcaUpdate
              childSr={true}
              ref={fatcaURef}
              showFooter={props.funcData.showFooter}
              enableSubmit={props.funcData.enableSubmit}
              onSubmit={props.funcData.onSubmit}
              childSrB={setFatcaB}
              loader={props.loader}
              setLoader={props.setLoader}
              hide={()=>setShow({ ...show, fatca: false })}
            />
          )}
          {show.income && (
            <IncomeDeclaration
              childSr={true}
              ref={incomeDRef}
              enableSubmit={props.funcData.enableSubmit}
              onSubmit={props.funcData.onSubmit}
              childSrB={setIncomeB}
              loader={props.loader}
              setLoader={props.setLoader}
            />
          )}
        </div>

        {show.email && (
          <div className="contactMsg">
            <label className="incomeMsg bold-text">Contact Details</label>
            {props.userData && (
              <EmailMobileModification
                childSr={true}
                ref={emailMobRef}
                userData={props.userData}
                showFooter={props.funcData.showFooter}
                enableSubmit={props.funcData.enableSubmit}
                onSubmit={props.funcData.onSubmit}
                srDropDown={props.funcData.srDropDown}
                childSrB={setEmailB}
                loader={props.loader}
                setLoader={props.setLoader}
                setBtnTxt={(val: any) => {
                  setBtnText(val === "Generate OTP" ? val : "Proceed");
                }}
                consentType ={consentType}
              />
            )}
          </div>
        )}

        <div className="modal-footer common-modal--footer">
          <div className="mob-center">
            <button
              type="submit"
              className="btn btn-blue login-btn"
              disabled={
                (show.fatca && !fatcaB) ||
                (show.income && !incomeB) ||
                (show.email && !emailB)
              }
              onClick={(e: any) => {
                parentCall();
                e.preventDefault();
              }}
            >
              {btnText}
            </button>

            <button
              type="submit"
              className="btn btn-olink login-btn"
              disabled={
                (consentType &&
                  (consentType?.includes("email") ||
                    consentType?.includes("mobile") ||
                    consentType?.includes("emailMob"))) ||
                addressConsent?.includes("Change of Address")
                  ? true
                  : false
              }
            >
              {!(
                (consentType &&
                  (consentType?.includes("email") ||
                    consentType?.includes("mobile") ||
                    consentType?.includes("emailMob"))) ||
                addressConsent?.includes("Change of Address")
              ) && (
                <a
                  className="btn btn-olink login-btn"
                  href={
                    window.location.href.includes("ajs")
                      ? config.rootUrl + "clientarea/servicerequest"
                      : config.root + "/clientarea/service-request"
                  }
                >
                  Cancel
                </a>
              )}
              {((consentType &&
                (consentType?.includes("email") ||
                  consentType?.includes("mobile") ||
                  consentType?.includes("emailMob"))) ||
                addressConsent?.includes("Change of Address")) && (
                <label className="btn btn-olink login-btn">Cancel</label>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};